<ax-text-box  [placeholder]="placeholder">
    <ax-button >
        <i class="fa-link fas"></i>  
   </ax-button> 
</ax-text-box>